<ng-container *ngIf="params.value">
	<img class="flag" [src]="'https://flags.fmcdn.net/data/flags/mini/' + params.value.code + '.png'" />
	{{ params.value.name }}
</ng-container>
